/* eslint-disable react/no-children-prop */
import _ from 'lodash';
import { Spinner } from 'reactstrap';
import { NoDataComponent } from '@/shared/ui';
import { DATA_HEATMAP_STATUS } from '@/shared/model';
import RrHeatmapButtonTypes from '@/widgets/beats/ui/rrHeatmapButtonTypes';
import TemplateOverview from '@/widgets/beats/ui/templateOverview';
import BeatEcgViewerWraper from './beatEcgViewerWrapper';
import HeatMapChart from './heatMapChart';
import StripBeats from './stripBeats';
import useRrInterval from './useRrInterval';
import './styles.scss';

/**
 * Renders the R-R interval review view of the beats tab, combining the beat strip list, the heatmap and the ECG viewer. Shows a spinner while the heatmap data status is loading or initial, a no-data component when it is empty, and appends the morphology template column only for the V and S beat types.
 *
 * @returns The R-R interval layout, a spinner, or a no-data placeholder depending on the heatmap data status.
 */
const RrInterval = () => {
  const {
    activeButton,
    currentDataHeatmapChartStatus,
    profileId,
    studyId,
    startReport,
    stopReport,
    timezoneOffset,
    ecgDataMap,
    callbackListDate,
  } = useRrInterval();

  if (
    currentDataHeatmapChartStatus === DATA_HEATMAP_STATUS.LOADING ||
    currentDataHeatmapChartStatus === DATA_HEATMAP_STATUS.INITIAL
  ) {
    return (
      <div className="beat-type-strip-content --rr-histogram">
        <div className="flex justify-center align-items-center h-100">
          <Spinner className="spinner-custom" children="" />
        </div>
      </div>
    );
  }

  if (currentDataHeatmapChartStatus === DATA_HEATMAP_STATUS.EMPTY) {
    return (
      <div className="no-beat-data">
        <NoDataComponent />
      </div>
    );
  }

  return (
    <div className="rr-interval-template-wrapper">
      <div className="beat-type-strip-content --rr-histogram">
        <RrHeatmapButtonTypes />
        <StripBeats
          ecgDataMap={ecgDataMap}
          profileId={profileId}
          studyId={studyId}
          timezoneOffset={timezoneOffset}
          callbackListDate={callbackListDate}
        />
        <div className="heatmap-and-ecg --min-width-strip-rr-heat-map">
          <HeatMapChart activeButton={activeButton} />
          <BeatEcgViewerWraper
            ecgDataMap={ecgDataMap}
            profileId={profileId}
            studyId={studyId}
            timezoneOffset={timezoneOffset}
            startReport={startReport}
            stopReport={stopReport}
            callbackListDate={callbackListDate}
          />
        </div>
      </div>
      {_.includes(['V', 'S'], activeButton as any) && (
        <div id="template-right-column" className="template-content-wrapper">
          <TemplateOverview />
        </div>
      )}
    </div>
  );
};

export default RrInterval;
